export default __webpack_public_path__ + "static/media/TiemposHeadline.1c24e15f.woff";